module.exports = __webpack_public_path__ + "6086c42d58e2ca9120ca3f3166a79ddd.svg";